import React from 'react';
import {connect} from 'react-redux';

const TvSubscriber = ({subscriber}) => {
const address = subscriber.customerAddress?.split(',').map(x => x.trim()).join(', ')?.trim();
const title = (address && address?.length != 1) ? address : (subscriber.productDesc ?? subscriber.packageName);



  return (
    <div className='subscriber'>
      <div className='title' title={title}><span className='text'>{title}</span>{subscriber?.productStatus != 'Active' && <span className='product-status'>{subscriber?.productStatusDesc}</span>}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TvSubscriber);
